import { Controller } from "@hotwired/stimulus"
export default class extends Controller {
  submit(event) {
    event.preventDefault()
    this.start()
    this.element.requestSubmit()
  }

  connect() {
    this.element.dataset.action += " turbo:submit-end->form#end"
  }

  start() {
    window.locked = true
    const event = new CustomEvent("form:saving", {bubbles: true})
    this.element.dispatchEvent(event)
  }

  end() {
    window.locked = false
    const event = new CustomEvent("form:saved", {bubbles: true})
    this.element.dispatchEvent(event)
  }
}
